import type { CalculateParams, CalculateSummary } from "../shared/types";
import type { ProjectionRow, Transaction } from "../shared/types";

export type AppStep = "import" | "configure" | "results";

export interface CalculationResult {
  warnings: string[];
  summary: CalculateSummary;
  all_transactions: Transaction[];
  projection: ProjectionRow[];
  csv: { transactions: string; projection: string };
}

export interface AppState {
  step: AppStep;
  transactions: Transaction[] | null;
  earliest: string | null;
  latest: string | null;
  bausparsummeHint: string | null;
  suggestedBausparsumme: number | null;
  params: CalculateParams;
  result: CalculationResult | null;
  statusMessage: string;
  statusTone: "muted" | "success" | "error" | "progress";
}

export function localTodayIso(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function defaultProjectionEnd(latestValueDate: string | null): string {
  if (!latestValueDate) return localTodayIso();
  const [y, m, d] = latestValueDate.split("-").map(Number);
  return `${y + 10}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
}

export function createDefaultParams(): CalculateParams {
  return {
    bausparsumme: 0,
    annual_interest_rate_pct: 0.01,
    zinsfaktor: 1335,
    divisor_per_bausparsumme: 0.004,
    target_bwz: 208,
    min_savings_ratio_pct: 45,
    projection_end: "",
    monthly_payment: 200,
    monthly_day: 2,
    yearly_payment_1: 175,
    yearly_month_1: 5,
    yearly_day_1: 15,
    yearly_payment_2: 0,
    yearly_month_2: 12,
    yearly_day_2: 31,
    annual_fee: 40,
    annual_fee_month: 1,
    annual_fee_day: 1,
    pay_now_amount: 0,
    pay_now_date: localTodayIso(),
  };
}

export function createInitialState(): AppState {
  return {
    step: "import",
    transactions: null,
    earliest: null,
    latest: null,
    bausparsummeHint: null,
    suggestedBausparsumme: null,
    params: createDefaultParams(),
    result: null,
    statusMessage: "Laden Sie eine PDF- oder CSV-Datei hoch. Die Verarbeitung erfolgt nur auf diesem Gerät.",
    statusTone: "muted",
  };
}
